import src from "IMAGE";
export default { src, width: 1032, height: 209, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAN0lEQVR42k3LMQ4AEBQE0U3+ISROpSEoJAqVY3BwIxrFy2aLkaSKjoaBhYD51vkts8xJKJ8bxAPHigY0xl1nugAAAABJRU5ErkJggg=="};
